import { render, staticRenderFns } from "./AdminTree.vue?vue&type=template&id=1029a134&scoped=true&"
import script from "./AdminTree.vue?vue&type=script&lang=js&"
export * from "./AdminTree.vue?vue&type=script&lang=js&"
import style0 from "./AdminTree.vue?vue&type=style&index=0&id=1029a134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1029a134",
  null
  
)

export default component.exports